import React from 'react';
import { BsX } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Box, Flex, HStack, Icon, IconButton } from '@chakra-ui/react';

import { removeArrayItemAtIndex } from '../../../../../../../../../../../../../../../utils/arrayUtil';
import FormInput from '../../../../../../../../../../../../../../form/FormInput';
import {
  customPolicyPropertiesStack,
  editCustomPolicyPropertiesStack
} from '../../../../../../../../../../../../../util/customPolicyFormStacks';

function LimitPropertyInputRow({ idx, useFormMethods, isEdit, fieldInputType, blueprint }) {
  const dispatch = useDispatch();
  const { setValue, getValues } = useFormMethods;
  const input = !isEdit ? customPolicyPropertiesStack[fieldInputType]
    : editCustomPolicyPropertiesStack[fieldInputType];

  return (
    <HStack
      alignItems="flex-start"
      flexFlow="row noWrap"
      height="auto"
      key={idx}
      position="relative"
    >
      <Box width={input?.width}>
        <FormInput
          caption={input?.caption}
          inputName={`${fieldInputType}.${idx}.${input.name}`}
          isReadOnly={input?.isReadOnly}
          key={`${input.name}_${idx}`}
          labelName={input.label}
          placeholder={input?.placeholder}
          required={input?.required}
          toolTip={input?.toolTip}
          type={input?.type}
          useFormMethods={useFormMethods}
          validationRules={input?.validationRules}
        />
      </Box>
      <Flex direction="column" height="100%" justifyContent="center">
        <IconButton
          aria-label="Delete Policy Property"
          icon={<Icon as={BsX} boxSize="34px" />}
          mt="25px"
          variant="textGrey"
          onClick={() => {
            const currentFormValues = getValues();

            if (currentFormValues?.[fieldInputType]?.length > 0) {
              const updatedValues = removeArrayItemAtIndex(
                currentFormValues[fieldInputType],
                idx
              );
              setValue(
                fieldInputType,
                updatedValues
              );
            }

            dispatch(blueprint.deleteCurrentPropertyInputOption(fieldInputType, idx));
          }}
        />
      </Flex>

    </HStack>
  );
}

export default LimitPropertyInputRow;
